export interface News {
    id?: string;
    centerGroupId?: number;
    title: string;
    description: string;
    creationDate: Date;
    previewFileName?: string;
    previewFileUri?: string;
    viewFileName?: string;
    viewFileUri?: string;
    viewFileType?: number;
    isPublished: boolean;

    // Campos para el formulario (archivos que se van a subir)
    thumbnailFile?: File;
    attachmentFile?: File;

    // Campos para retrocompatibilidad con el código existente
    publicationDate?: Date; // mapeado desde creationDate
    thumbnailUrl?: string; // mapeado desde previewFileUri
    attachmentUrl?: string; // mapeado desde viewFileUri
    createdAt?: Date; // mapeado desde creationDate
    updatedAt?: Date;
}

export interface NewsFormData {
    title: string;
    publicationDate: Date;
    description: string;
    isPublished: boolean;
    thumbnailFile?: File;
    attachmentFile?: File;
}

// Interface para la respuesta de la API
export interface NewsApiResponse {
    id: string;
    centerGroupId: number;
    title: string;
    description: string;
    creationDate: string;
    previewFileName: string;
    previewFileUri: string;
    viewFileName: string;
    viewFileUri: string;
    viewFileType: number;
    viewUrl: string;
    isPublished: boolean;
}

// Interface para enviar datos a la API
export interface NewsCreateRequest {
    title: string;
    description: string;
    isPublished: boolean;
    previewFile?: File;
    viewFile?: File;
}

export interface NewsUpdateRequest {
    id: string;
    title: string;
    description: string;
    isPublished: boolean;
    previewFile?: File;
    viewFile?: File;
}